import { Avatar, Box, Stack, Typography } from "@mui/material";
import React from "react";
import {
  appOptionsStyles,
  cardStyles,
  containerStyles,
  scanButtonInnerStyles,
  scanButtonWrapperStyles,
} from "../../style";
import { useAppSelector } from "../../../../../Redux/hooks";
import MobileMockup from "../../../../Common/UI/MobileMockup";

const MenuScreenPreview = () => {
  const previewData = useAppSelector((state) => state.appCustomization.data);
  return (
    <Box sx={containerStyles}>
      <Stack
        sx={{ p: 2.5, height: "100%" }}
        justifyContent={"center"}
        direction={"row"}
      >
        <MobileMockup width={350}>
          <Stack sx={cardStyles} justifyContent="space-between">
            <Stack sx={{ height: "100%" }}>
              <Stack
                direction={"row"}
                sx={{
                  px: 2,
                  pt: 2,
                  bgcolor: "#F7F2FF",
                  borderRadius: "32px 32px 0px 0px",
                  height: "35%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Stack gap={1}>
                  <Stack alignItems={"center"}>
                    <Avatar sx={{ height: "54px", width: "54px" }} />
                  </Stack>
                  <Stack alignItems={"center"}>
                    <Typography variant="h6" fontWeight={"bold"}>
                      William Liu
                    </Typography>
                    <Typography variant="body1">
                      williamliu@gmail.com
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
              <Stack sx={{ bgcolor: "white", height: "65%", p: 2 }} gap={1}>
                {[
                  {
                    title: "Discover Recipes",
                    subtitle: "Check the details of your discover recipes",
                    enabled: previewData?.[0]?.enabled,
                  },
                  {
                    title: "Appointments",
                    subtitle: "Schedule your appointments",
                    enabled: previewData?.[1]?.enabled,
                  },
                  {
                    title: "Medications",
                    subtitle: "Set up reminders to medication intake",
                    enabled: previewData?.[2]?.enabled,
                  },
                  {
                    title: "Account settings",
                    subtitle: "Delete account",
                    enabled: previewData?.[3]?.enabled,
                  },
                ]
                  .filter((item) => item.enabled)
                  .map((item, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        p: 2,
                        borderRadius: "8px",
                        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                        bgcolor: "#F9F9F9",
                      }}
                    >
                      <Stack>
                        <Typography fontWeight="bold">
                          {previewData?.[index]?.text || item.title}
                        </Typography>
                        <Typography
                          fontSize="12px"
                          color="primary.main"
                          fontWeight={400}
                        >
                          {item.subtitle}
                        </Typography>
                      </Stack>
                      <Typography
                        fontSize="16px"
                        fontWeight="bold"
                        color="gray"
                      >
                        &gt;
                      </Typography>
                    </Stack>
                  ))}
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              sx={appOptionsStyles}
              gap={2.5}
              justifyContent={"space-between"}
            >
              <Stack
                alignItems={"center"}
                sx={{ width: "36px", height: "36px" }}
              >
                <Avatar
                  sx={{ width: "36px", height: "36px" }}
                  src={"path-to-active-icon"}
                />
                <Typography fontSize={"10px"} fontWeight={500}>
                  Home
                </Typography>
              </Stack>
              <Stack
                alignItems={"center"}
                sx={{ width: "36px", height: "36px" }}
              >
                <Avatar
                  sx={{ width: "36px", height: "36px" }}
                  src={"path-to-default-icon"}
                />
                <Typography fontSize={"10px"} fontWeight={500}>
                  Learn
                </Typography>
              </Stack>
              <Stack alignItems={"center"} sx={scanButtonWrapperStyles}>
                <Stack
                  sx={{
                    ...scanButtonInnerStyles,
                    width: "64px",
                    height: "64px",
                  }}
                >
                  <Avatar
                    sx={{ width: "36px", height: "36px" }}
                    src={"path-to-default-icon"}
                  />
                  <Typography fontSize={"10px"} fontWeight={500}>
                    Scan
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                alignItems={"center"}
                sx={{ width: "36px", height: "36px" }}
              >
                <Avatar
                  sx={{ width: "36px", height: "36px" }}
                  src={"path-to-default-icon"}
                />
                <Typography fontSize={"10px"} fontWeight={500}>
                  Profile
                </Typography>
              </Stack>
              <Stack
                alignItems={"center"}
                sx={{ width: "36px", height: "36px" }}
              >
                <Avatar
                  sx={{ width: "36px", height: "36px" }}
                  src={"path-to-default-icon"}
                />
                <Typography
                  fontSize={"10px"}
                  fontWeight={500}
                  color={"#ff4713"}
                >
                  Menu
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </MobileMockup>
      </Stack>
    </Box>
  );
};

export default MenuScreenPreview;
